<template>
  <nav class="mobile-tabbar">
    <router-link to="/" class="item" :class="{ active: current === 'home' }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 19h16M7 16V10M12 16V5M17 16v-4" />
      </svg>
      <span>{{ $t('home') }}</span>
    </router-link>

    <router-link to="/myPool" class="item" :class="{ active: current === 'pool' }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3l7 4-7 4-7-4 7-4zM5 11l7 4 7-4M5 15l7 4 7-4" />
      </svg>
      <span>{{ $t('pool') }}</span>
    </router-link>

    <router-link to="/service" class="item" :class="{ active: current === 'service' }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z" />
      </svg>
      <span>{{ $t('service') }}</span>
    </router-link>

    <router-link to="/share" class="item" :class="{ active: current === 'invite' }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3 20a6 6 0 0 1 12 0M17 8v6M20 11h-6" />
      </svg>
      <span>{{ $t('invite') }}</span>
    </router-link>

    <router-link to="/account" class="item" :class="{ active: current === 'account' }">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM5 20a7 7 0 0 1 14 0" />
      </svg>
      <span>{{ $t('account') }}</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "MobileTabBar",
  i18n: {
    zh: { home: "首页", pool: "矿池", service: "服务", invite: "邀请", account: "帐户" },
    en: { home: "Home", pool: "Pool", service: "Service", invite: "Invite", account: "Account" },
  },
  props: {
    current: {
      type: String,
      default: "home",
    },
  },
};
</script>

<style scoped>
.mobile-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 12px;
  z-index: 30;
  max-width: 406px;
  margin: 0 auto;
  height: 62px;
  background: rgba(12, 17, 34, 0.72);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border: 1px solid rgba(150, 170, 225, 0.16);
  border-radius: 22px;
  box-shadow: 0 20px 40px -18px rgba(0, 0, 0, 0.85);
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.item {
  position: relative;
  color: var(--pool-muted);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3px;
  font-size: 12px;
}

.item svg {
  width: 18px;
  height: 18px;
  stroke: currentColor;
  stroke-width: 1.8;
  fill: none;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.item.active {
  color: var(--pool-teal);
}

.item.active::before {
  content: "";
  position: absolute;
  top: 8px;
  width: 20px;
  height: 3px;
  border-radius: 3px;
  background: var(--pool-grad);
}
</style>
